import React from 'react'
import clsx from 'clsx'
import { StandardProps } from '../../types/common'
import styles from './Menu.module.scss'

export const MenuLink: React.FC<StandardProps> = ({ children, className }) => {
  return React.cloneElement(children as React.ReactElement, {
    className: clsx(className, styles['hds-menu__link']),
  })
}
